import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Commits ligados a uma novidade (só leitura).
 * @param {{ commits: Array<{ hash: string, subject: string }> }} props
 */
function ItemCommitsList({ commits }) {
  const list = Array.isArray(commits) ? commits : [];
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        Commits ({list.length})
      </Typography>
      {list.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8125rem' }}>
          Criada no Admin, sem commits.
        </Typography>
      ) : (
        <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mt: 0.5, display: 'grid', gap: 0.5 }}>
          {list.map((commit) => (
            <Box component="li" key={commit.hash} sx={{ display: 'flex', gap: 1, fontSize: '0.8125rem', minWidth: 0 }}>
              <Box component="code" sx={{ color: 'text.secondary', flexShrink: 0 }}>{String(commit.hash).slice(0, 8)}</Box>
              <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={commit.subject}>
                {commit.subject || '—'}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default ItemCommitsList;
